export enum PermissionTypes {
  AddPlannedDentalTransactionItemWithoutAppointment = "ADD_PLANNED_DENTAL_TRANSACTION_ITEM_WITHOUT_APPOINTMENT",
}
